const GlobalConfig = {

  // Local Backend URL
  // API_BASE_URL: 'http://localhost:8000/', 
  
  // Lite Grocer Backend URL
  API_BASE_URL: 'https://service.litegrocer.lk/',
  
  // Testing Backend URL
  // API_BASE_URL: 'https://navajowhite-newt-293708.hostingersite.com/',

  token: localStorage.getItem('cashier_token') || null,
  user: JSON.parse(localStorage.getItem('cashier_user') || 'null'),
  currentShift: JSON.parse(localStorage.getItem('current_shift') || 'null')
};

export const setToken = (token) => {
  GlobalConfig.token = token;
  localStorage.setItem('cashier_token', token);
};

export const setUser = (user) => {
  GlobalConfig.user = user;
  localStorage.setItem('cashier_user', JSON.stringify(user));
};

export const setCurrentShift = (shift) => {
  GlobalConfig.currentShift = shift;
  localStorage.setItem('current_shift', JSON.stringify(shift));
};

export const clearAuth = () => {
  GlobalConfig.token = null;
  GlobalConfig.user = null;
  GlobalConfig.currentShift = null;
  localStorage.removeItem('cashier_token');
  localStorage.removeItem('cashier_user');
  localStorage.removeItem('current_shift');
};

export default GlobalConfig;